"use strict";

var t,
    o = require("react"),
    n = (t = o) && "object" == typeof t && "default" in t ? t.default : t;

function e(t) {
  if ("undefined" != typeof window) {
    var o = document.createElement("script");
    o.type = "text/javascript", void 0 !== o.async && (o.async = !0), o.src = ("https:" == window.location.protocol ? "https://d1pna5l3xsntoj.cloudfront.net" : "http://cdn.addwish.com") + "/scripts/company/awAddGift.js#" + t;
    var n = document.getElementsByTagName("script")[0];
    n && n.parentNode && n.parentNode.insertBefore(o, n);
  }
}

function r() {
  if ("undefined" == typeof window) throw new Error("Addwish is client only");
  if (!window.ADDWISH_PARTNER_NS) throw new Error("Addwish client not loaded");
}

function i() {
  a() && window.ADDWISH_PARTNER_NS && window.ADDWISH_PARTNER_NS.api.reload();
}

function a() {
  return "undefined" != typeof window && !!window.ADDWISH_PARTNER_NS;
}

function c(t) {
  return new Promise(function (o, n) {
    try {
      r(), window.ADDWISH_PARTNER_NS && window.ADDWISH_PARTNER_NS.api.cart.setCart(t, function () {
        o();
      });
    } catch (t) {
      n(t);
    }
  });
}

function d(t) {
  var o = t.boxes,
      n = t.callback,
      e = t.errorCallback;
  "undefined" != typeof window && requestAnimationFrame(function () {
    return window._awev.push(["bind", "context_ready", function () {
      var t, r;
      null === (t = window) || void 0 === t || null === (r = t.ADDWISH_PARTNER_NS) || void 0 === r || r.api.recom.load(o, {
        format: "json"
      }, n, e);
    }]);
  });
}

function u(t, o) {
  var n,
      e,
      i,
      a = t && t.cart && t.cart.items && t.cart.items.map(function (t) {
    return t && t.articleNumber;
  }) || [],
      d = (null == t ? void 0 : null === (n = t.cart) || void 0 === n ? void 0 : n.id) || window.localStorage.getItem("cartId");
  if (null == t ? void 0 : t.cart) return a.length > 0 ? c({
    productNumbers: a,
    total: (null == t ? void 0 : null === (e = t.cart) || void 0 === e ? void 0 : null === (i = e.productTotal) || void 0 === i ? void 0 : i.incVat) + "",
    url: document.location.protocol + "//" + document.location.hostname + "/externalcheckout.aspx?cartid=" + d
  }) : d && 0 === a.length ? new Promise(function (t, o) {
    try {
      r(), window.ADDWISH_PARTNER_NS && window.ADDWISH_PARTNER_NS.api.cart.clearCart(t);
    } catch (t) {
      o(t);
    }
  }) : void 0;
}

function s() {
  return (s = Object.assign || function (t) {
    for (var o = 1; o < arguments.length; o++) {
      var n = arguments[o];

      for (var e in n) Object.prototype.hasOwnProperty.call(n, e) && (t[e] = n[e]);
    }

    return t;
  }).apply(this, arguments);
}

function l(t) {
  return (l = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  })(t);
}

function f(t, o) {
  return (f = Object.setPrototypeOf || function (t, o) {
    return t.__proto__ = o, t;
  })(t, o);
}

function p(t, o, n) {
  return (p = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
    } catch (t) {
      return !1;
    }
  }() ? Reflect.construct : function (t, o, n) {
    var e = [null];
    e.push.apply(e, o);
    var r = new (Function.bind.apply(t, e))();
    return n && f(r, n.prototype), r;
  }).apply(null, arguments);
}

function w(t) {
  var o = "function" == typeof Map ? new Map() : void 0;
  return (w = function (t) {
    if (null === t || -1 === Function.toString.call(t).indexOf("[native code]")) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");

    if (void 0 !== o) {
      if (o.has(t)) return o.get(t);
      o.set(t, n);
    }

    function n() {
      return p(t, arguments, l(this).constructor);
    }

    return n.prototype = Object.create(t.prototype, {
      constructor: {
        value: n,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), f(n, t);
  })(t);
}

"undefined" == typeof window || Array.isArray(window._awev) || (window._awev = []);

var m,
    h = function (t) {
  var o, n;

  function e(o, n) {
    var e,
        r = n.recommendationBoxId,
        i = n.items;
    return e = t.call(this, o) || this, console.error(o, {
      items: i,
      recommendationBoxId: r
    }), e;
  }

  return n = t, (o = e).prototype = Object.create(n.prototype), o.prototype.constructor = o, o.__proto__ = n, e;
}(w(Error));

function v(t) {
  var o = t.items,
      n = t.recommendationBoxId;
  if (!Array.isArray(o)) throw new h("Result property wasn't an array", {
    items: o,
    recommendationBoxId: n
  });
  if (o.length > 0 && "string" != typeof o[0].productNumber) throw new h('"productNumber" needs to be a string', {
    items: o,
    recommendationBoxId: n
  });
}

(m = exports.LoadingState || (exports.LoadingState = {})).LOADING = "LOADING", m.ERROR = "ERROR", m.SUCCESS = "SUCCESS", exports.AddwishProvider = function (t) {
  return n.createElement(n.Fragment, null, t.children);
}, exports.addAddwishProductToCart = function (t) {
  try {
    r(), window.ADDWISH_PARTNER_NS && window.ADDWISH_PARTNER_NS.api.cart.addProduct({
      productNumber: t
    });
  } catch (t) {
    console.log(t);
  }
}, exports.addwishTracker = function (t) {
  return {
    name: "addwish",
    initBrowser: function () {
      e(t);
    },
    trackPageView: function () {
      requestAnimationFrame(function () {
        return i();
      });
    },
    trackCart: function (t, o) {
      u(t);
    },
    trackCartCheckout: function (t, o) {
      u(t);
    },
    trackProduct: function (t) {
      var o = t.product;

      switch (t.action) {
        case "click":
          if (null == o ? void 0 : o.addwishData) {
            var n,
                e,
                r,
                i = new URL(null == o ? void 0 : null === (n = o.addwishData) || void 0 === n ? void 0 : n.url).hash.slice(1).split("=");
            null === (e = window) || void 0 === e || null === (r = e.ADDWISH_PARTNER_NS) || void 0 === r || r.api.tracking.track_click(i[1]);
          }

      }
    }
  };
}, exports.fetchAddwishRecommendations = d, exports.isAddwishLoaded = a, exports.loadAddwishScript = e, exports.reloadAddwish = i, exports.setAddwishCart = c, exports.trackCart = u, exports.useAddwish = function (t) {
  var n = t.boxes,
      e = t.pageLoaded,
      r = {};
  Object.keys(n).forEach(function (t) {
    r[t] = {
      items: [],
      loading: exports.LoadingState.LOADING
    };
  });
  var i = o.useState(r),
      a = i[0],
      c = i[1],
      u = o.useState(!1),
      l = u[0],
      f = u[1];
  return o.useEffect(function () {
    l || e && (d({
      boxes: n,
      callback: function (t, o) {
        v({
          items: o,
          recommendationBoxId: t
        }), c(function (n) {
          var e;
          return s({}, n, ((e = {})[t] = {
            items: o,
            loading: exports.LoadingState.SUCCESS
          }, e));
        });
      },
      errorCallback: function (t, o, n) {
        console.error("fetchAddwishRecommendations error", n), c(function (o) {
          var n;
          return s({}, o, ((n = {})[t] = {
            items: [],
            loading: exports.LoadingState.ERROR
          }, n));
        });
      }
    }), f(!0));
  }, [n]), {
    addWishResponseBoxItems: a
  };
}, exports.validateResponseBox = v; //# sourceMappingURL=flight-addwish.cjs.production.min.js.map